define('shoptheme/components/ui/generated-menu',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem"
], function(
	$,
	Component,
	BEM
) {

	return Component.create({

		blocks: null,

		$init: function() {
			this.blocks = $('[data-links-source-selector]');
			this.blocks.each(function() {
				var block = $(this),
					nav = block.find('ul.nav'),
					sourceSelector = block.data('links-source-selector'),
					sources = $(sourceSelector);

				sources.each(function(index, obj){
					var source = $(obj),
						generatedLi = $('<li>'),
						generatedLink = $(
							'<a>',
							{
								href: '#' + source.attr('id'),
								text: source.find('h3').text()
							}
						);
					nav.append(generatedLi.append(generatedLink));
				});

				$('body').scrollspy('refresh');
			});

		}

	});

});

